import React from 'react';
import Header from '../../componentes/comuns/Header';
import Footer from '../../componentes/comuns/Footer';
import Carousel from '../../componentes/comuns/carrossel';
import ServicosEssenciais from '../../componentes/comuns/ServicosEssenciais';
import Contato from '../../componentes/comuns/Contato';
import ServicosEssenciaisInternet from '../../componentes/comuns/ServicosEssenciaisInternet';
import InfinitePossibilities from '../../componentes/comuns/InfinitePossibilities';
import AppExclusivo from '../../componentes/comuns/AppExclusivo';
import PlanoControle from '../../componentes/comuns/PlanoControle';
import TelefoniaBanner from '../../componentes/comuns/TelefoniaBanner';
import HelpSection from '../../componentes/comuns/HelpSection';
import Ofertas from '../../componentes/comuns/Ofertas';
import { config, shouldShowComponent } from '../../data';
import styles from './Inicio.module.css';

const Inicio = () => {
  const desktopImages = config.images.banners.desktop;
  const mobileImages = config.images.banners.mobile;

  return (
    <>
      {shouldShowComponent('global', 'header') && <Header />}
      <main className={styles.mainContent}>
        {shouldShowComponent('inicio', 'carousel') && (
          <Carousel images={desktopImages} mobileImages={mobileImages} interval={5000} />
        )}
        
        {shouldShowComponent('inicio', 'servicosEssenciais') && <ServicosEssenciais />}
        
        {shouldShowComponent('inicio', 'ofertas') && (
          <div className={styles.Ofertas}>
            <Ofertas/>
          </div>
        )}
        
        {shouldShowComponent('inicio', 'servicosEssenciaisInternet') && (
          <div>
            <ServicosEssenciaisInternet />
          </div>
        )}
        
        {shouldShowComponent('inicio', 'contato') && (
          <div className={styles.contato}>
            <Contato />
          </div>
        )}
        
        {shouldShowComponent('inicio', 'infinitePossibilities') && (
          <div>
            <InfinitePossibilities />
          </div>
        )}
        
        {shouldShowComponent('inicio', 'appExclusivo') && (
          <div className={styles.AppExclusivo}>
            <AppExclusivo />
          </div>
        )}
        
        {shouldShowComponent('inicio', 'planoControle') && (
          <div>
            <PlanoControle />
          </div>
        )}
        
        {shouldShowComponent('inicio', 'telefoniaBanner') && (
          <div className={styles.TelefoniaBanner}>
            <TelefoniaBanner />
          </div>
        )}
        
        {shouldShowComponent('inicio', 'helpSection') && (
          <div>
            <HelpSection />
          </div>
        )}
      </main>
      {shouldShowComponent('global', 'footer') && <Footer />}
    </>
  );
};

export default Inicio;